<template>
  <div
    class="md:px-24 px-5 w-full justify-center flex flex-col items-center bg-grey rounded-b-[60px] md:rounded-b-[120px] pb-10 md:pb-20"
  >
    <div class="text-center font-primary uppercase text-5xl font-medium">
      Contact
    </div>
    <div class="text-center font-primary text-xl mt-10">
      Bei Anliegen und Fragen klicke einfach hier!
    </div>
    <a href="mailto:blackoutmagazin@gmail.com" class="mt-8">
      <button
        class="px-8 py-2 border md:hover:bg-black uppercase md:hover:text-white duration-300 border-black text-center font-primary text-black rounded-full"
      >
        Klick mich
      </button>
    </a>
    <img
      class="mt-10 md:w-auto w-1/3"
      src="../assets/imgs/alaska-signature-black.svg"
      alt=""
    />
  </div>
</template>
